import * as  actions from './file.actions';
import { File } from './file.model';
import { State } from './file.reducer';

export const updateFromApiReducer = (
    state: State,
    action: actions.UpdateFromApi
): State => {

    return action.payload.files
        .reduce((s, remote) => {

            const local = s.entities[remote.id];

            // the remote object does not exist locally
            if (!local) {
                s.ids = [...s.ids, remote.id];
                s.entities[remote.id] = new File(remote);
                return s;
            }

            if (
                local.modified && remote.serverModified > local.modified ||
                !local.modified && remote.serverModified > local.serverModified
            ) {
                s.entities[remote.id] = new File(remote);
            }
            return s;
        }, {
            ...state,
            // we need to clone the objects to avoid Object.lock errors
            ids: [...state.ids],
            entities: {...state.entities}
        } as State);
};



// WEBPACK FOOTER //
// ./src/vas/business-objects/file/update-from-api.reducer.ts